import { Globe } from "lucide-react";
import { useI18n, LANGS } from "../i18n";

export const LanguageSwitcher = ({ dark = false }) => {
  const { lang, setLang, t } = useI18n();
  return (
    <div className="flex flex-col items-end" data-testid="language-switcher">
      <div
        className={`flex h-9 items-center gap-1.5 rounded-full border px-3 transition-colors ${
          dark
            ? "border-white/20 bg-white/10 hover:bg-white/20"
            : "border-slate-200 bg-white hover:border-slate-300"
        }`}
      >
        <Globe className={`h-3.5 w-3.5 ${dark ? "text-slate-300" : "text-slate-500"}`} />
        <select
          value={lang}
          onChange={(e) => setLang(e.target.value)}
          className={`cursor-pointer bg-transparent text-xs font-semibold outline-none ${
            dark ? "text-white" : "text-slate-700"
          }`}
          aria-label={t("lang.label")}
          data-testid="language-select"
        >
          {LANGS.map((l) => (
            <option key={l.code} value={l.code} className="bg-white text-slate-900">
              {l.short}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
